import { render, staticRenderFns } from "./AtfAccordionList.vue?vue&type=template&id=6789396a&"
import script from "./AtfAccordionList.vue?vue&type=script&lang=js&"
export * from "./AtfAccordionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports